import { JSX } from 'react';
import { SaldoDTO } from '../../model/Saldo';
import { PlusIcon } from '../../icons/Plus';
import { MinIcon } from '../../icons/Min';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';

const formatAmount = (amount: number): string => {
  return amount.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
};

export const berekenRekeningGroepIcoonKleur = (saldo: SaldoDTO): string => {
  if (saldo.budgetOpPeilDatum === 0 && saldo.periodeBetaling === 0) {
    return '#1977d3';
  }
  switch (saldo.budgetType?.toLowerCase()) {
    case 'inkomsten':
      return saldo.minderDanBudget > 0 ? 'red' : 'green';
    case 'continu':
      return (saldo.meerDanMaandBudget > 0 ? '#c00' : saldo.meerDanBudget > 0)
        ? 'red'
        : 'green';
    case 'vast':
      return saldo.minderDanBudget > 0 || saldo.periodeAchterstand < 0
        ? 'red'
        : saldo.meerDanMaandBudget > 0 || saldo.meerDanBudget > 0
          ? 'orange'
          : 'green';
    case 'sparen':
      return 'orange';
    default:
      return 'black';
  }
};

export const berekenRekeningGroepIcoonOpKleur = (
  heigth: number,
  color: string,
): JSX.Element => {
  switch (color) {
    case 'green':
    case '#1977d3':
      return <PlusIcon color={color} height={heigth} />;
    case 'red':
    case '#c00':
      return <MinIcon color={color} height={heigth} />;
    // case 'orange':
    //   return <UitroeptekenIcon color={color} height={heigth} />;
    default:
      return <QuestionMarkOutlinedIcon color={'disabled'} height={heigth} />;
  }
};

export const berekenRekeningGroepIcoon = (
  heigth: number,
  saldo: SaldoDTO,
): JSX.Element => {
  return berekenRekeningGroepIcoonOpKleur(
    heigth,
    berekenRekeningGroepIcoonKleur(saldo),
  );
};

export const berekenStandBodyTekst = (
  rekeningGroepSaldo: SaldoDTO,
  rekeningSaldi: SaldoDTO[],
): string => {
  const fouteRekeningen = rekeningSaldi
    .filter(
      (saldo) =>
        berekenRekeningGroepIcoonKleur(saldo) !== 'green' &&
        berekenRekeningGroepIcoonKleur(saldo) !== '#1977d3',
    )
    .map((saldo) => saldo.rekeningNaam);
  if (fouteRekeningen.length === 0) {
    return (
      `${rekeningGroepSaldo.rekeningGroepNaam} precies ok` +
      (rekeningGroepSaldo.openingsAchterstand < 0
        ? ` en de achterstand zelfs helemaal weggewerkt!`
        : '!')
    );
  } else if (fouteRekeningen.length === 1) {
    return `${rekeningGroepSaldo.rekeningGroepNaam} niet ok, check ${fouteRekeningen[0]}.`;
  } else if (fouteRekeningen.length === 2) {
    return (
      `${rekeningGroepSaldo.rekeningGroepNaam} niet ok, check ` +
      fouteRekeningen.join(' en ')
    );
  } else {
    return (
      `${rekeningGroepSaldo.rekeningGroepNaam} niet ok, check ` +
      fouteRekeningen.slice(0, -1).join(', ') +
      ' en ' +
      fouteRekeningen.slice(-1)
    );
  }
};

export const berekenStandDetailsTekst = (
  rekeningSaldi: SaldoDTO[],
): string[] => {
  const fouteRekeningen = rekeningSaldi.filter(
    (saldo) =>
      saldo.periodeAchterstand < 0 ||
      (berekenRekeningGroepIcoonKleur(saldo) !== 'green' &&
        berekenRekeningGroepIcoonKleur(saldo) !== '#1977d3'),
  );

  return fouteRekeningen.map((saldo) => {
    switch (saldo.budgetType?.toLowerCase()) {
      case 'inkomsten':
        if (saldo.periodeBetaling === 0) {
          return `${saldo.rekeningNaam}: verwachte ${formatAmount(saldo.budgetOpPeilDatum)} niet ontvangen (betaaldag ${saldo.budgetBetaalDag}e)`;
        } else
          return `${saldo.rekeningNaam}: ${formatAmount(saldo.minderDanBudget)} minder dan de verwachte ${formatAmount(saldo.budgetOpPeilDatum)}`;
      case 'continu':
        return `${saldo.rekeningNaam}: ${formatAmount(saldo.meerDanBudget + saldo.meerDanMaandBudget)} meer besteed dan de verwachte ${formatAmount(saldo.budgetOpPeilDatum)}`;
      case 'vast': {
        const achterstand =
          saldo.periodeAchterstand < 0
            ? ` ${formatAmount(-saldo.periodeAchterstand)} achterstand`
            : '';
        if (saldo.periodeBetaling === 0) {
          return `${saldo.rekeningNaam}:${achterstand} deze periode niet betaald (betaaldag ${saldo.budgetBetaalDag}e)`;
        } else if (saldo.meerDanBudget > 0 || saldo.meerDanMaandBudget > 0) {
          return `${saldo.rekeningNaam}: ${formatAmount(saldo.meerDanBudget + saldo.meerDanMaandBudget)} meer betaald dan het maandbudget van ${formatAmount(saldo.budgetMaandBedrag)}.`;
        } else if (saldo.periodeAchterstand < 0) {
          return (
            `${saldo.rekeningNaam}: ${achterstand}` +
            (saldo.minderDanBudget > 0
              ? ` ${formatAmount(saldo.minderDanBudget)} te weinig betaald.`
              : '.')
          );
        } else
          return `${saldo.rekeningNaam}: ${formatAmount(saldo.minderDanBudget)} te weinig betaald.`;
      }
      default:
        return 'black';
    }
  });
};
